"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = exports.Position = void 0;
var react_1 = __importStar(require("react"));
var Modal_1 = require("./modal/Modal");
var debounce_1 = require("../helpers/debounce");
var VerticalAlignment;
(function (VerticalAlignment) {
    VerticalAlignment[VerticalAlignment["Top"] = 1] = "Top";
    VerticalAlignment[VerticalAlignment["Middle"] = 2] = "Middle";
    VerticalAlignment[VerticalAlignment["Bottom"] = 4] = "Bottom";
})(VerticalAlignment || (VerticalAlignment = {}));
var HorizontalAlignment;
(function (HorizontalAlignment) {
    HorizontalAlignment[HorizontalAlignment["Left"] = 8] = "Left";
    HorizontalAlignment[HorizontalAlignment["Center"] = 16] = "Center";
    HorizontalAlignment[HorizontalAlignment["Right"] = 32] = "Right";
})(HorizontalAlignment || (HorizontalAlignment = {}));
var Position;
(function (Position) {
    Position[Position["TopLeft"] = 9] = "TopLeft";
    Position[Position["MiddleLeft"] = 10] = "MiddleLeft";
    Position[Position["BottomLeft"] = 12] = "BottomLeft";
    Position[Position["TopCenter"] = 17] = "TopCenter";
    Position[Position["MiddleCenter"] = 18] = "MiddleCenter";
    Position[Position["BottomCenter"] = 20] = "BottomCenter";
    Position[Position["TopRight"] = 33] = "TopRight";
    Position[Position["MiddleRight"] = 34] = "MiddleRight";
    Position[Position["BottomRight"] = 36] = "BottomRight";
})(Position = exports.Position || (exports.Position = {}));
var SNAP_THRESHOLD = 16;
var getTopOffset = function (rectangle, position) {
    if (VerticalAlignment.Bottom & position) {
        return rectangle.height;
    }
    else if (VerticalAlignment.Middle & position) {
        return rectangle.height / 2;
    }
    return 0;
};
var getLeftOffset = function (rectangle, position) {
    if (HorizontalAlignment.Right & position) {
        return rectangle.width;
    }
    else if (HorizontalAlignment.Center & position) {
        return rectangle.width / 2;
    }
    return 0;
};
var Panel = function (props) {
    // Destructure Panel props
    var anchorOrigin = props.anchorOrigin, panelOrigin = props.panelOrigin, constantProps = __rest(props, ["anchorOrigin", "panelOrigin"]);
    var anchorElement = constantProps.anchorElement, _a = constantProps.panelSize, panelSize = _a === void 0 ? {
        width: "auto",
        height: "auto",
    } : _a, className = constantProps.className, draggable = constantProps.draggable, anchorElementClickable = constantProps.anchorElementClickable, disableXSnapping = constantProps.disableXSnapping, disableYSnapping = constantProps.disableYSnapping, modalProps = __rest(constantProps, ["anchorElement", "panelSize", "className", "draggable", "anchorElementClickable", "disableXSnapping", "disableYSnapping"]);
    var panelRef = react_1.useRef(null);
    var isDragging = false;
    var dragTopOffset = 0;
    var dragLeftOffset = 0;
    var classes = [];
    var modalClasses = [];
    var setPosition = react_1.useCallback(function () {
        var panelEl = panelRef.current;
        if (!panelEl) {
            return;
        }
        panelEl.style.position = "absolute";
        var top = 0;
        var bottom = undefined; // Stays undefined unless required (when space is tight and flipping disabled)
        var left = 0;
        var anchorRect;
        if (anchorElement) {
            anchorRect = anchorElement.getBoundingClientRect();
            anchorOrigin !== null && anchorOrigin !== void 0 ? anchorOrigin : (anchorOrigin = Position.BottomLeft);
            panelOrigin !== null && panelOrigin !== void 0 ? panelOrigin : (panelOrigin = Position.TopLeft);
        }
        else {
            // Use the body as the anchor
            anchorRect = document.documentElement.getBoundingClientRect();
            anchorOrigin = Position.MiddleCenter;
            panelOrigin = Position.MiddleCenter;
        }
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        // SIZING
        if (panelSize.width === "auto") {
            panelEl.style.width = "";
        }
        else {
            if (panelSize.width === "matchAnchor") {
                panelEl.style.width = anchorRect.width + "px";
            }
            else {
                panelEl.style.width = panelSize.width;
            }
        }
        if (panelSize.height === "auto") {
            panelEl.style.height = "";
        }
        else {
            if (panelSize.height === "matchAnchor") {
                panelEl.style.height = anchorRect.height + "px";
            }
            else {
                panelEl.style.height = panelSize.height;
            }
        }
        var panelRect = panelEl.getBoundingClientRect();
        // POSITION
        // Set position of the anchor element
        top += anchorRect.top + getTopOffset(anchorRect, anchorOrigin);
        left += anchorRect.left + getLeftOffset(anchorRect, anchorOrigin);
        // Adjust for panel origin
        top -= getTopOffset(panelRect, panelOrigin);
        left -= getLeftOffset(panelRect, panelOrigin);
        // SNAPPING
        // Flip Y direction if panel is going to be outside viewport on Y axis.
        var panelWouldFallOutsideViewPortOnYAxis = top < SNAP_THRESHOLD || top + panelRect.height > windowHeight - SNAP_THRESHOLD;
        var wouldBeTop = top;
        var panelOriginIsTop = VerticalAlignment.Top & panelOrigin;
        var panelOriginIsBottom = VerticalAlignment.Bottom & panelOrigin;
        if (!props.disableYSnapping && panelWouldFallOutsideViewPortOnYAxis) {
            var anchorOriginIsTop = VerticalAlignment.Top & anchorOrigin;
            var anchorOriginIsBottom = VerticalAlignment.Bottom & anchorOrigin;
            if ((anchorOriginIsTop && panelOriginIsTop) ||
                (anchorOriginIsBottom && panelOriginIsBottom)) {
                // Both panel and origin are the same (both top or both bottom)
                // In this case, add/subtract the difference between the top/bottom respectively
                // to keep the direction snap inside the anchor
                if (anchorOriginIsTop) {
                    wouldBeTop = anchorRect.bottom - panelRect.height;
                }
                else {
                    wouldBeTop = anchorRect.top;
                }
            }
            else {
                // Both panel and origin are different (one top and one bottom or vice versa)
                // In this case, add/subtract the heights to snap over the anchor
                if (panelOriginIsTop) {
                    wouldBeTop -= panelRect.height;
                }
                else if (panelOriginIsBottom) {
                    wouldBeTop += panelRect.height;
                }
                // If the anchor origin isn't in the middle, then also need to snap
                // over the height of the anchor
                if (anchorOriginIsTop) {
                    wouldBeTop += anchorRect.height;
                }
                else if (anchorOriginIsBottom) {
                    wouldBeTop -= anchorRect.height;
                }
            }
        }
        /**
         * If the flipped panel would still fall outside the viewport, calculate
         * if it has more room in it's original or flipped position
         */
        var flippedPanelWouldFallOutsideViewPortOnYAxis = wouldBeTop < SNAP_THRESHOLD ||
            wouldBeTop + panelRect.height > windowHeight - SNAP_THRESHOLD;
        if (flippedPanelWouldFallOutsideViewPortOnYAxis) {
            // Work out best place (more room in original or flipped position)
            var originalDeltaOutsideViewport = 0;
            var wouldBeDeltaOutsideViewport = 0;
            if (panelOriginIsTop) {
                // If panel original is top, then original panel top is guaranteed to be inside viewport
                originalDeltaOutsideViewport = top + panelRect.height - windowHeight;
                wouldBeDeltaOutsideViewport = wouldBeTop;
            }
            else if (panelOriginIsBottom) {
                // If panel origin is bottom, then the original panel top is probably going to be outside the viewport
                originalDeltaOutsideViewport = top;
                wouldBeDeltaOutsideViewport = wouldBeTop + panelRect.height - windowHeight;
            }
            // There is more space on the original side when less of the panel falls outside the viewport
            var moreSpaceOnOriginalSide = Math.abs(originalDeltaOutsideViewport) < Math.abs(wouldBeDeltaOutsideViewport);
            if (moreSpaceOnOriginalSide) {
                // There's more space in the original position, so better staying here, but lock panel height
                if (panelOriginIsTop) {
                    // When panel origin is top, stop the bottom going outside the viewport
                    bottom = windowHeight - SNAP_THRESHOLD;
                }
                else {
                    // When panel origin is bottom, stop the top going outside the viewport
                    bottom = top + panelRect.height; // Put bottom where it would be
                    top = SNAP_THRESHOLD; // Force top lower than top of viewport
                }
            }
            else {
                // There's more space in the flipped position, so flip, but lock panel height
                if (panelOriginIsTop) {
                    top = SNAP_THRESHOLD;
                    bottom = wouldBeTop + panelRect.height - top - SNAP_THRESHOLD;
                }
                else {
                    bottom = windowHeight - SNAP_THRESHOLD;
                }
            }
        }
        else {
            // Flipped panel doesn't fall outside viewport, so set new position
            top = wouldBeTop;
        }
        if (!props.disableXSnapping &&
            (left < SNAP_THRESHOLD || left + panelRect.width > windowWidth - SNAP_THRESHOLD)) {
            var anchorOriginIsLeft = HorizontalAlignment.Left & anchorOrigin;
            var anchorOriginIsRight = HorizontalAlignment.Right & anchorOrigin;
            var panelOriginIsLeft = HorizontalAlignment.Left & panelOrigin;
            var panelOriginIsRight = HorizontalAlignment.Right & panelOrigin;
            if ((anchorOriginIsLeft && panelOriginIsLeft) ||
                (anchorOriginIsRight && panelOriginIsRight)) {
                // Both panel and origin are the same (both left or both right)
                // In this case, add/subtract the difference between the left/right respectively
                // to keep the direction snap inside the anchor
                if (anchorOriginIsLeft) {
                    left = anchorRect.right - panelRect.width;
                }
                else {
                    left = anchorRect.left;
                }
            }
            else {
                // Both panel and origin are different (one left and one right or vice versa)
                // In this case, add/subtract the widths to snap over the anchor
                if (panelOriginIsLeft) {
                    left -= panelRect.width;
                }
                else if (panelOriginIsRight) {
                    left += panelRect.width;
                }
                // If the anchor origin isn't in the center, then also need to snap
                // over the width of the anchor
                if (anchorOriginIsLeft) {
                    left += anchorRect.width;
                }
                else if (anchorOriginIsRight) {
                    left -= anchorRect.width;
                }
            }
        }
        // Set styles on the element
        panelEl.style.top = top + "px";
        panelEl.style.left = left + "px";
        if (bottom !== undefined) {
            var panelMaxHeight = top + bottom;
            var newPanelHeight = panelRect.height < panelMaxHeight ? panelRect.height : panelMaxHeight;
            panelEl.style.height = newPanelHeight + "px";
        }
        else {
            panelEl.style.height = "";
        }
    }, [anchorElement, anchorOrigin, panelOrigin, panelSize]);
    react_1.useEffect(function () {
        if (!modalProps.isOpen) {
            return;
        }
        var handleWindowResize = debounce_1.debounce(setPosition);
        var handleMouseUp = function () {
            isDragging = false;
            if (panelRef.current) {
                panelRef.current.style.pointerEvents = "initial";
            }
        };
        var handleMouseMove = function (e) {
            if (isDragging && panelRef.current) {
                var windowHeight = window.innerHeight || document.documentElement.clientHeight;
                var windowWidth = window.innerWidth || document.documentElement.clientWidth;
                var height = panelRef.current.clientHeight;
                var width = panelRef.current.clientWidth;
                var top_1 = e.clientY + dragTopOffset;
                var left = e.clientX + dragLeftOffset;
                // Don't go outside the screen
                if (top_1 < SNAP_THRESHOLD) {
                    top_1 = SNAP_THRESHOLD;
                }
                else if (top_1 + height > windowHeight - SNAP_THRESHOLD) {
                    top_1 = windowHeight - SNAP_THRESHOLD - height;
                }
                if (left < SNAP_THRESHOLD) {
                    left = SNAP_THRESHOLD;
                }
                else if (left + width > windowWidth - SNAP_THRESHOLD) {
                    left = windowWidth - SNAP_THRESHOLD - width;
                }
                panelRef.current.style.top = top_1 + "px";
                panelRef.current.style.left = left + "px";
            }
        };
        var handleMouseDownClick = function (e) {
            var currentElement = e.target; // We know better in this case
            var anchorOrPanelClicked = false;
            /**
             * This loop runs through each element, starting with the event target
             * and working up through the lineage of elements up to the document.
             *
             * If, during the loop, the panel or anchor element is seen, the
             * click is dismissed
             *
             * A previous attempt using z-indexes was made to lift the anchor
             * element above the backdrop so that it could remain clickable while
             * the rest of the page wasn't. While this would work in simple cases,
             * it would not work when there are panels inside other panels due
             * to the behaviour of z-indexes.
             */
            while (currentElement !== null) {
                if (currentElement === anchorElement || currentElement === panelRef.current) {
                    anchorOrPanelClicked = true;
                    break;
                }
                currentElement = currentElement.parentElement;
            }
            if (!anchorOrPanelClicked) {
                /**
                 * Anchor or panel was NOT clicked. To prevent accidental navigation
                 * or other actions, stop this click from going any further and
                 * close the modal (equivalent to a modal overlay click)
                 */
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                if (e.type === "click" && props.onRequestClose) {
                    props.onRequestClose();
                }
                return false;
            }
        };
        if (props.anchorElementClickable) {
            // If the anchor element is clickable, some special event handlers
            // are required in order to preserve modal behaviour
            document.addEventListener("mousedown", handleMouseDownClick, true);
            document.addEventListener("click", handleMouseDownClick, true);
        }
        window.addEventListener("resize", handleWindowResize);
        if (draggable) {
            document.addEventListener("mouseup", handleMouseUp);
            document.addEventListener("mousemove", handleMouseMove);
        }
        return function () {
            window.removeEventListener("resize", handleWindowResize);
            document.removeEventListener("mousedown", handleMouseDownClick, true);
            document.removeEventListener("click", handleMouseDownClick, true);
            if (draggable) {
                document.removeEventListener("mouseup", handleMouseUp);
                document.removeEventListener("mousemove", handleMouseMove);
            }
        };
    }, [anchorElement, modalProps.isOpen, draggable]);
    react_1.useEffect(function () {
        if (modalProps.isOpen) {
            setPosition();
        }
    });
    var handleMouseDown = function (e) {
        if (!draggable) {
            return;
        }
        e.preventDefault();
        isDragging = true;
        if (panelRef.current) {
            dragTopOffset = panelRef.current.offsetTop - e.clientY;
            dragLeftOffset = panelRef.current.offsetLeft - e.clientX;
            panelRef.current.style.pointerEvents = "none";
        }
        return false;
    };
    if (className) {
        classes.push(className);
    }
    return (react_1.default.createElement(Modal_1.Modal, __assign({}, modalProps, { pointerEventPassthrough: anchorElementClickable, className: modalClasses.join(" ") }),
        react_1.default.createElement("div", { className: classes.join(" "), ref: panelRef, onMouseDown: handleMouseDown }, props.children)));
};
exports.Panel = Panel;
exports.Panel.Position = Position;
//# sourceMappingURL=Panel.js.map